import { render, staticRenderFns } from "./ScaleDropDownSelector.vue?vue&type=template&id=143dd0f6&scoped=true&"
import script from "./ScaleDropDownSelector.vue?vue&type=script&lang=ts&"
export * from "./ScaleDropDownSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143dd0f6",
  null
  
)

export default component.exports